import { render, staticRenderFns } from "./PopOverLink.vue?vue&type=template&id=6e8e2700"
import script from "./PopOverLink.vue?vue&type=script&lang=js"
export * from "./PopOverLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8e2700')) {
      api.createRecord('6e8e2700', component.options)
    } else {
      api.reload('6e8e2700', component.options)
    }
    module.hot.accept("./PopOverLink.vue?vue&type=template&id=6e8e2700", function () {
      api.rerender('6e8e2700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/PopOverLink.vue"
export default component.exports